import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { setLenis, getLenis } from "./lib/scroll";
import { Nav } from "./components/site/Nav";
import { Hero } from "./components/site/Hero";
import { Marquee } from "./components/site/Marquee";
import { About } from "./components/site/About";
import { Services } from "./components/site/Services";
import { Projects } from "./components/site/Projects";
import { VideoGallery } from "./components/site/VideoGallery";
import { WhyUs } from "./components/site/WhyUs";
import { Testimonials } from "./components/site/Testimonials";
import { Estimate } from "./components/site/Estimate";
import { SurveyBooking } from "./components/site/SurveyBooking";
import { Contact } from "./components/site/Contact";
import { Footer } from "./components/site/Footer";
import { WhatsAppFloat } from "./components/site/WhatsAppFloat";
import { Preloader } from "./components/site/Preloader";
import { ScrollProgress } from "./components/site/ScrollProgress";
import { CookieConsent } from "./components/site/CookieConsent";
import { CaseStudy } from "./components/site/CaseStudy";
import { CookiesPage } from "./components/site/CookiesPage";
import { Admin } from "./components/site/Admin";

const ScrollReset = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    getLenis()?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Home = () => (
  <>
    <Nav />
    <main>
      <Hero />
      <Marquee />
      <About />
      <Services />
      <Projects />
      <VideoGallery />
      <WhyUs />
      <Testimonials />
      <Estimate />
      <SurveyBooking />
      <Contact />
    </main>
    <Footer />
    <WhatsAppFloat />
  </>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    setLenis(lenis);
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white font-body text-ink antialiased">
      <Preloader />
      <Toaster theme="light" position="bottom-right" />
      <BrowserRouter>
        <ScrollReset />
        <ScrollProgress />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects/:slug" element={<CaseStudy />} />
          <Route path="/cookies" element={<CookiesPage />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <CookieConsent />
      </BrowserRouter>
    </div>
  );
}

export default App;
